const createOption = (label: string) => ({
  label,
  value: label,
});
export default createOption;